module.exports = __webpack_public_path__ + "img/Gruppe.ebbb5118.svg";